/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, answerError } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED : STORY CTA : STYLES --------------- ++++++++++ */
export default theme => ({
    storycta: {
        height: '10',
        textAlign: 'left',
        position: 'relative',
        zIndex: '3',
        marginTop: pxToEm(16),
        '& .text': {
            height: '100%',
            fontSize: pxToEm(26),
            fontWeight: 'bold',
            lineHeight: '1.1',
            border: replacePXinStringWithEM('1px solid transparent'),
            transition: 'border-width 0.2s ease-out',
            '& .editabletext': {
                textDecoration: 'underline'
            },
            '& .editabletext:empty': {
                textDecoration: 'none'
            }
        },

        '&.valid-false': {
            extend: answerError.text
        },
        // not supported in IE https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-within
        '&:focus-within': {
            border: replacePXinStringWithEM('1px solid #fff'),
            transition: 'border-width 0.2s ease-in'
        }
    }
});
